import landingPage from '@/views/year2020/landingPage/math'
export default {
    path: '/oversea-math',
    name: 'oversea-math',
    component: landingPage,
    description: '海外数学落地页'
}